<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      @if (!paramId) {
      <ion-button (click)="create()" [disabled]="anyFieldInvalid()">{{
        "machinery.create" | translate
      }}</ion-button>
      } @if (paramId) {
      <ion-button (click)="update()" [disabled]="anyFieldInvalid()">{{
        "machinery.update" | translate
      }}</ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    @if(paramId){
    <div class="field" style="display: flex">
      <lib-image-preview
        [fileOrBlob]="profilePicture"
        style="height: 200px"
        (click)="openFile()"
      ></lib-image-preview>
      <div style="margin-left: 10px">
        <ion-button (click)="openImageInput()" style="min-width: 160px"
          ><ion-icon
            name="cloud-upload-outline"
            slot="start"
            class="white"
          ></ion-icon
          >{{ "machinery.changeImage" | translate }}</ion-button
        >
      </div>
    </div>
    }

    <lib-upload
      style="width: 100%"
      (filesChanged)="setUploadFiles($event, true)"
      [isProfilePicture]="true"
      [autoUpload]="true"
      [machineId]="paramId"
      [displayName]="
        machine?.inventoryNumber +
        ' ' +
        machine?.manufacturer +
        ' ' +
        machine?.type
      "
    ></lib-upload>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        [placeholder]="'machinery.categoryExamples' | translate"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.category"
        ><div slot="label">
          {{ "machinery.category" | translate }}*
        </div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [placeholder]="'machinery.typeExamples' | translate"
        [(ngModel)]="this.machine.type"
        ><div slot="label">{{ "common.type" | translate }}*</div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.constructionYear"
        ><div slot="label">
          {{ "machinery.constructionYear" | translate }}*
        </div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.manufacturer"
        ><div slot="label">
          {{ "machinery.manufacturer" | translate }}*
        </div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.serialNumber"
        ><div slot="label">
          {{ "machinery.serialNumber" | translate }}*
        </div></ion-input
      >
    </div>
    <div class="field">
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.machine.inventoryNumber"
        (ionInput)="handleInventoryNumberInput($event)"
        ><div slot="label">
          {{ "machinery.inventoryNumber" | translate }}*
        </div></ion-input
      >
      @if(showDuplicateInventoryNumberError){
      <div>{{ "machinery.inventoryNumberExists" | translate }}</div>
      }
    </div>
    <div class="field">
      <ion-textarea
        [label]="'common.notes' | translate"
        labelPlacement="floating"
        fill="outline"
        [autoGrow]="true"
        mode="md"
        [(ngModel)]="machine.notes"
        [placeholder]="'common.addNotes' | translate"
      ></ion-textarea>
    </div>
    <div class="field">
      <ion-checkbox
        stlye="margin-bottom:10px"
        [(ngModel)]="this.machine.inspectionFree"
        >{{ "machinery.noInspectionRequired" | translate }}</ion-checkbox
      >
    </div>
    @if(machine.inspectionFree && !machine.nextManualInspection){
    <div class="field">
      <ion-button (click)="showDatePicker = true" fill="outline">{{
        "machinery.addManualInspectionDate" | translate
      }}</ion-button>
    </div>

    } @if(machine.inspectionFree && (machine.nextManualInspection ||
    showDatePicker)){
    <div class="field stretch space-between">
      <div>{{ "machinery.nextInspection" | translate }}</div>
      <div class="stretch">
        <lib-date-time-picker
          [type]="'date'"
          [inputDateZulu]="machine.nextManualInspection"
          (selectedDateChanged)="dateChanged($event)"
        ></lib-date-time-picker>
        <ion-icon
          name="trash-outline"
          class="red"
          (click)="removeManualInspection()"
        ></ion-icon>
      </div>
    </div>
    } @if(paramId){
    <div class="field stretch space-between">
      <div>{{ "common.documents" | translate }}</div>
      @if(filesToUpload?.length < 1){
      <ion-button (click)="openFileInput()"
        ><ion-icon
          name="cloud-upload-outline"
          slot="start"
          class="white"
        ></ion-icon
        >{{ "common.addDocuments" | translate }}</ion-button
      >
      }
    </div>

    @if(paramId){
    <lib-upload
      style="width: 100%"
      [machineId]="paramId"
      (filesChanged)="setUploadFiles($event, false)"
      [displayName]="
        machine?.inventoryNumber +
        ' ' +
        machine?.manufacturer +
        ' ' +
        machine?.type
      "
      (uniqueIdChanged)="setUniqueId($event)"
    ></lib-upload>
    } @for(doc of machineDocuments; track doc.id){
    @if(!filesToDelete.includes(doc.id)){
    <div class="stretch space-between document">
      <div class="centered">
        <ion-icon
          [name]="state.getIcon(doc)"
          style="margin-right: 5px"
        ></ion-icon>
        <div>{{ doc.displayName }}</div>
      </div>
      <ion-icon
        name="trash-outline"
        class="red"
        (click)="deleteFile(doc.id)"
      ></ion-icon>
    </div>
    } } }
    <br />
  </div>
</ion-content>
